import type { HTMLAttributes, ReactNode } from "react";

export function Notice({ children, title, tone = "neutral", icon, presentation, actions, ...props }: HTMLAttributes<HTMLDivElement> & { children: ReactNode; title: string; icon?: ReactNode; tone?: "caution" | "danger" | "neutral" | "positive"; presentation?: "contextual"; actions?: ReactNode }) {
  return <div {...props} className={`notice notice--${tone}${presentation ? ` notice--${presentation}` : ""}`} role={tone === "danger" ? "alert" : "status"}><span aria-hidden="true">{icon ?? (tone === "danger" ? "!" : tone === "positive" ? "✓" : "•")}</span><div className="notice-content"><strong>{title}</strong>{children}</div>{actions ? <div className="notice-actions">{actions}</div> : null}</div>;
}

export function Skeleton({ height = 10, width = "100%" }: { height?: number; width?: string }) {
  return <span className="skeleton" aria-hidden="true" style={{ display: "block", height, width }} />;
}

export function EmptyState({ action, children, title }: { action?: ReactNode; children: ReactNode; title: string }) {
  return <section className="empty-state"><h2>{title}</h2><p>{children}</p>{action}</section>;
}
